import { withFormsy } from 'formsy-react'
import React from 'react'
import VoucherStartEndTime from './VoucherStartEndTime'
const VoucherStartEndTimeFormsy = (props) => {
  const { setValue, ...rest } = props
  return <VoucherStartEndTime {...rest} onChange={setValue} />
}

export default withFormsy(VoucherStartEndTimeFormsy)
